export const VARIATION_OPTION = 'VariationOption';
//# sourceMappingURL=variation-option.js.map